//ts-check
import {Button, HeaderTitle} from '@/components/atoms'
import {BrandsSection} from '@/containers/Content/ProductCatalog/BrandsSection'
import {CategoriesSection} from '@/containers/Content/ProductCatalog/CategoriesSection'
import {useProductCatalog} from '@/containers/Content/ProductCatalog/hooks/useProductCatalog'
import {usePublishProductCatalog} from '@/containers/Content/ProductCatalog/hooks/usePublishProductCatalog'
import {Header} from '@/utils/constants/header'

export const ProductCatalog = () => {
  const {
    brands,
    categories,
    isLoading,
    setBrands,
    handleBrandsReorder,
    handleSubcategoriesReorder,
    handleCategoriesReorder,
    toggleSubcategoryVisibility,
  } = useProductCatalog()
  const {publishProductCatalog, isPublishing} = usePublishProductCatalog()

  const handlePublishChanges = async () => {
    await publishProductCatalog({brands, categories})
  }

  return (
    <div className="product-categories flex flex-col gap-6 pb-8">
      <HeaderTitle title="Product Categories" headingLevel={Header.PageHeader} className="$font-heading-h3-bold" />
      <BrandsSection brands={brands} setBrands={setBrands} isLoading={isLoading} onDragEnd={handleBrandsReorder} />
      <CategoriesSection
        categories={categories}
        isLoading={isLoading}
        onDragEnd={handleCategoriesReorder}
        onSubcategoryDragEnd={handleSubcategoriesReorder}
        onToggleSubcategoryVisibility={toggleSubcategoryVisibility}
      />
      <div className="flex justify-end">
        <Button
          handleButton={handlePublishChanges}
          uiSchema={{title: isPublishing ? 'Publishing...' : 'Publish Changes', size: 'medium', disabled: isPublishing}}
        />
      </div>
    </div>
  )
}
